import {ShortConactInterface} from '@app/marketplace/checkout/_models/contact.model';
import {PaymentProfileInterface} from '@app/marketplace/checkout/_models/payment-profile.model';
import {CustomDescriptiveNumberItemModel, CustomSummaryItemsInterface, CustomTextItemInterface} from '@app/marketplace/checkout/_models/custom.model';
import {INotification, ResponseModel} from '@app/marketplace/core/models/response.model';

export class CheckoutBaseInputModel {
  contactId: string;
  signature: string;
  sendReceipt: boolean;

  constructor(model?) {
    model = model || {};
    this.contactId = model.contactId || '';
    this.signature = model.signature || '';
    this.sendReceipt = model.sendReceipt || true;
  }
}
export class CheckoutSyncModel extends CheckoutBaseInputModel {
  items: any;
}

export interface CheckoutInterface {
  signature: string;
  contact: ShortConactInterface;
  shipments: CheckoutShipmentsInterface[];
  hasContacts: boolean;
  requeriments: CheckoutRequirementsInterface;
  isValid: boolean;
  checkoutId: string;
  summary: CustomTextItemInterface;
  summaryItems: CustomSummaryItemsInterface[];
  cleanSummaryData: CustomDescriptiveNumberItemModel[];
  totalPriceToShow: string;
  totalPrice: number;
  paymentMethods: CheckoutPaymentMethodInterface;
}

export class CheckoutResponse extends ResponseModel<CheckoutInterface> {}

export interface CheckoutPaymentMethodInterface {
  zipCodeRequired: boolean;
  paymentProfiles: PaymentProfileInterface[];
}

export interface CheckoutRequirementsInterface {
  addressVerificationRequired: boolean;
  nameIsReadOnly: boolean;
  termsAndConditionsRequired: boolean;
  clientName: string;
  clientPhone: string;
  lowAddressToShow: string;
  topAddressToShow: string;
  showSenderDetails: boolean;
}

export interface CheckoutShipmentsInterface {
  description: string;
  deliveryIcon: DeliveryIcon;
  deliveryToShow: string;
  deliveryDetails: CustomTextItemInterface;
  items: CheckoutShipmentItemInterface[];
  shippingCharge: number;
  notificationItem?: INotification;
}

export interface CheckoutShipmentItemInterface {
  notificationItem: any;
  quantity: number;
  maxQuantity: number;
  priceToShow: string;
  oldPriceToShow: string;
  previewUrl: string;
  code: string;
  name: string;
  shortText: string;
  price: number;
  supplierCode: string;
  supplierLinkToShow: string;
}

export interface AddressVerificationInterface {
  firstName: string;
  lastName: string;
  phone: string;
  addrLine1: string;
  addrLine2: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  countryISO: string;
  countryISO2: string;
}

export class AddressVerificationResponse extends ResponseModel<AddressVerificationInterface> {
}


export enum DeliveryIcon {
  /// <summary>
  /// Estimated Delivery
  /// </summary>
  Estimated = 0,
  /// <summary>
  /// Guaranteed Delivery
  /// </summary>
  Guaranteed = 1,
  /// <summary>
  /// Variable Delivery
  /// </summary>
  Variable = 2
}
